var trailSlider = document.getElementById("trail-length");
var trailNumber = document.getElementById("trail-number");

var tiltSlider = document.getElementById("window-tilt");
var tiltNumber = document.getElementById("tilt-number");

trailSlider.addEventListener("change", (event) => {
    trailNumber.value = trailSlider.value;
});

trailNumber.addEventListener("change", (event) => {
    trailSlider.value = trailNumber.value;
});

tiltSlider.addEventListener("change", (event) => {
    maxAngle = tiltSlider.value;
    tiltNumber.value = tiltSlider.value;
});

tiltNumber.addEventListener("change", (event) => {
    maxAngle = tiltNumber.value;
    tiltSlider.value = tiltNumber.value;
});

if (window.matchMedia("(max-width: 600px)").matches) {
    maxAngle = 0;
    tiltNumber.value = 0;
    tiltSlider.value = 0;
}